import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { SnackbarService } from "../service/snackbar.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const sbService = inject(SnackbarService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        sbService.openSnackBar(`An error occurred: ${error.error.message}`, 'Close');
      } else {
        if (error.status === 401 && error.error?.error?.message === "Invalid credentials") {
          authService.setTokenExpired(true);
          sbService.openSnackBar(`Authentication failed: The session has expired. Please login again to continue`, 'Close');
          router.navigate(['/blank']); // Navigate to the blank page
          return throwError(() => error);
        } else if (error.status === 401 && error.error?.error?.message === "User not found") {
          authService.setTokenExpired(true);
          sbService.openSnackBar(`Authentication failed with user not found message: The account doesn't have access to CSI. Please contact support`, 'Close');
          router.navigate(['/blank']); // Navigate to the blank page
          return throwError(() => error);
        } else if (error.status === 0) {
          // Comms to the server failed token expiry
          authService.setTokenExpired(true);
          sbService.openSnackBar(`Authentication failed: The session has expired. Please login again to continue`, 'Close');
          router.navigate(['/blank']); // Navigate to the blank page
          return throwError(() => error);
        } else {
          // The backend returned an unsuccessful response code.
          if (error.error?.error?.message) {
            sbService.openSnackBar(`Server ERROR: ${error.error.error.message}`, 'Close');
          } else {
            sbService.openSnackBar(`Server ERROR: Not able to load data from API. Please contact support`, 'Close');
          }
        }
      }
      return throwError(() => 'An error occurred, please try again later.');
    }),
    tap(() => {
      authService.setTokenExpired(false);
    })
  );
};
